const vendorAttachments = (() => {
    let vendorID;
    let attachmentsEntries;

    //Attachment
    let attachmentsBtn;
    let reviewAttachmentArray = [];
    let DDNumber;
    let LocalNumber;
    let Phone;
    let Name;

    async function init(vendorId, DDNum, localNum, phone, name) {
        vendorID = vendorId;
        DDNumber = DDNum;
        LocalNumber = localNum;
        Phone = phone;
        Name = name;
        attachmentsEntries = await authorizationsAjax.getVenderAttachmentsEntriesAsync(vendorID);
    }

    function getMarkup() {       
        const vendorAttachmentsWrap = document.createElement('div');
        vendorAttachmentsWrap.classList.add('planSummary');

        const importantTables = buildNewAttachmentsForm();
        vendorAttachmentsWrap.appendChild(importantTables);

        return vendorAttachmentsWrap;
    }
    function showNewAttachmentForm() {
        reviewAttachmentArray = []
        vendorAddAttachment.init(reviewAttachmentArray, vendorID);       
    }
    function buildNewAttachmentsForm() {
        const vendorAttachmentsDiv = document.createElement('div');
        vendorAttachmentsDiv.classList.add('additionalQuestionWrap');

        attachmentsEntriesTable = buildAttachmentsEntriesTable();

        const headers = attachmentsEntriesTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // attachments

        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Attachments</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        addNewCardBody.appendChild(attachmentsEntriesTable);     

        vendorAttachmentsDiv.appendChild(column1);

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(attachmentsEntriesTable);

        return vendorAttachmentsDiv;
    }

    function buildAttachmentsEntriesTable() {
        const tableOptions = {
            plain: false,
            tableId: 'vendorInfoTable',
            columnHeadings: ['Attachment'],
            endIcon: $.session.authorizationsVendorInfoUpdate == true ? true : false,
        };

        let tableData = attachmentsEntries.getVenderAttachmentsEntriesResult.map((entry) => ({
            values: [entry.attachmentDescription],
            onClick: (e) => {
                reviewAttachmentArray = [];
                let attachmentArray = { description: entry.attachmentDescription, attachmentId: entry.attachmentId };
                reviewAttachmentArray.push(attachmentArray);
                vendorAddAttachment.init(reviewAttachmentArray, vendorID);
            },
            endIcon: $.session.authorizationsVendorInfoUpdate == true ? `${icons['delete']}` : '',
            endIconCallback: (e) => {
                deleteAttachmentPOPUP(entry.attachmentId);
            },

        }));
        const oTable = table.build(tableOptions);
        table.populate(oTable, tableData);

        return oTable;
    }

    function deleteAttachmentPOPUP(attachmentId) {
        const confirmPopup = POPUP.build({
            hideX: true,
        });

        YES_BTN = button.build({
            text: 'YES',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                deleteVenderAttachment(attachmentId, confirmPopup);
            },
        });

        NO_BTN = button.build({
            text: 'NO',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(confirmPopup);
            },
        });

        const message = document.createElement('p');

        message.innerText = 'Are you sure you would like to remove this attachment?';
        message.style.textAlign = 'center';
        message.style.marginBottom = '15px';
        confirmPopup.appendChild(message);
        var popupbtnWrap = document.createElement('div');
        popupbtnWrap.classList.add('btnWrap');
        popupbtnWrap.appendChild(YES_BTN);
        popupbtnWrap.appendChild(NO_BTN);
        confirmPopup.appendChild(popupbtnWrap);
        YES_BTN.focus();
        POPUP.show(confirmPopup);
    }

    function deleteVenderAttachment(attachmentId, confirmPopup) {
        authorizationsAjax.deleteVenderAttachment(
            {
                attachmentID: attachmentId
            },
            function (results) {
                if (results = 'sucess') {
                    POPUP.hide(confirmPopup);
                    refreshPage();
                }
            },
        );
    }

    function refreshPage() {
        newVendorInfo.refreshVendor(vendorID, DDNumber, LocalNumber, Phone, Name, tabPositionIndex = 6);
    }

    return {
        init,
        buildNewAttachmentsForm,
        getMarkup,
        refreshPage,
        showNewAttachmentForm,
    };
})(); 
